<template>
<div class="search-leaps-meditation">
  <div class="container-fluid">
    <div class="row margin-Top-2Perc">
      <div class="col-md-1 col-lg-1 font-size-18px margin-left0Point3Perc padding-right-0Perc margin-top-2px">
        Search
      </div>
      <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 width-34Point2Perc padding-left-12px margin-right-1Point1Perc">
        <div class="form-group margin-bottom-0px">
          <div class="icon-addon addon-lg">
            <input type="text" class="form-control background-gray border-rounded" v-model="enteredLeapsMeditationNameInSearch" autocomplete="off"/>
            <label class="glyphicon glyphicon-search"></label>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-lg-2 font-size-18px left-border width-14Point5Perc padding-Left-2Point1Perc">
        <button type="button" class="btn gray-border white-BG margin-auto margin-Top-1Perc" v-on:click="openCreateLeapsMeditationOverlay($event)">+ Create New</button>
      </div>
      <div class="col-md-2 col-lg-2 font-size-18px width-14Point5Perc text-align-left padding-Left-0px">
        <button type="button" class="btn gray-border white-BG margin-auto margin-Top-1Perc" v-on:click="exportGivenMeditationRecords()" :disabled="leapsMeditationListValue.length === 0">Export</button>
      </div> 
    </div>
    <create-leaps-meditation-overlay v-if="!hideCreateLeapsMeditationOverlay" @emittedValue="updateEmittedValue"></create-leaps-meditation-overlay>
    <loader></loader>   
  </div>
</div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import CreateLeapsMeditationOverlay from '@/components/leaps/meditation/CreateLeapsMeditationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { forEach } from 'lodash'
import csvHelper from '@/utils/csv-helper'
export default {
  created: function () {},
  data: function () {
    return {
      hideCreateLeapsMeditationOverlay: true,
      enteredLeapsMeditationNameInSearch: null,
      showSpinner: false
    }
  },
  name: 'search-leaps-meditation',
  methods: {
    updateEmittedValue (recievedObj) {
      this.hideCreateLeapsMeditationOverlay = recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
      var objToEmit = {
        updateValues: false,
        SortType: '',
        ColumnName: ''
      }
      this.$emit('sortBasedOnColumnName', objToEmit)
    },
    exportGivenMeditationRecords: function () {
      var columnAlias = ['Title', 'Caption File', 'HD Video Url', 'Auto Video Url', 'Low Video Url', 'Audio Url', 'Created On', 'Updated On']
      var columnRespKey = ['MeditationTitle', 'CaptionFile', 'HDVideoUrl', 'AutoVideoUrl', 'LowVideoUrl', 'AudioUrl', 'CreatedTS', 'UpdatedTS']
      var respArr = []
      forEach(this.leapsMeditationListValue, (obj) => {
        if (obj.UpdatedTS.indexOf('Z') === -1) {
          obj.UpdatedTS += 'Z'
        }
        if (obj.CreatedTS.indexOf('Z') === -1) {
          obj.CreatedTS += 'Z'
        }
        var objToPush = {
          MeditationTitle: obj.MeditationTitle,
          AudioUrl: (obj.AudioUrl !== undefined && obj.AudioUrl !== 'undefined' && obj.AudioUrl !== null && obj.AudioUrl !== 'null' && obj.AudioUrl !== '') ? obj.AudioUrl : 'Not Found.',
          CaptionFile: (obj.CaptionUrl !== undefined && obj.CaptionUrl !== 'undefined' && obj.CaptionUrl !== null && obj.CaptionUrl !== 'null' && obj.CaptionUrl !== '') ? obj.CaptionUrl : 'Not Found.',
          AutoVideoUrl: (obj.VideoUrl !== undefined && obj.VideoUrl !== null && obj.VideoUrl !== '') ? obj.VideoUrl : 'Not Found.',
          HDVideoUrl: (obj.HDVideoUrl !== undefined && obj.HDVideoUrl !== null && obj.HDVideoUrl !== '') ? obj.HDVideoUrl : 'Not Found.',
          LowVideoUrl: (obj.LowQualityVideoUrl !== undefined && obj.LowQualityVideoUrl !== null && obj.LowQualityVideoUrl !== '') ? obj.LowQualityVideoUrl : 'Not Found.',
          CreatedTS: dmAdminUtils.covertUtcToEst(obj.CreatedTS),
          UpdatedTS: dmAdminUtils.covertUtcToEst(obj.UpdatedTS)
        }
        respArr.push(objToPush)
      })
      return csvHelper.export(respArr, columnRespKey, columnAlias, 'Meditation')
    },
    findBy: function (list, value, column) {
      return list.filter(function (item) {
        return String(item[column]).toLowerCase().indexOf(String(value).toLowerCase()) !== -1
      })
    },
    openCreateLeapsMeditationOverlay ($event) {
      this.hideCreateLeapsMeditationOverlay = false
      this.$store.state.isOverlayVisible = true
    }
  },
  computed: {
    leapsMeditationListValue: {
      get: function () {
        return this.$store.state.leapsMeditationList
      }
    }
  },
  watch: {
    enteredLeapsMeditationNameInSearch: function () {
      if (this.enteredLeapsMeditationNameInSearch !== null) {
        this.$emit(
          'searchResult',
          this.findBy(
            this.leapsMeditationListValue,
            this.enteredLeapsMeditationNameInSearch,
            'MeditationTitle'
          )
        )
      } else {
        this.$emit('searchResult', this.leapsMeditationListValue)
      }
    }
  },
  components: {
    'create-leaps-meditation-overlay': CreateLeapsMeditationOverlay,
    'loader': Loader
  }
}
</script>
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red {
  background-color: red;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-0Perc {
  margin-top: 0%;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-4Perc {
  margin-top: 4%;
}
.margin-Top-3Point5Perc {
  margin-top: 3.5%;
}
.margin-Top-8Perc {
  margin-top: 8%;
}
.margin-bottom-0Perc {
  margin-bottom: 0%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-left-0Perc {
  margin-left: 0%;
}
.margin-left0Point3Perc {
  margin-left: .3%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-left-3Perc {
  margin-left: 3%;
}
.margin-left-4Perc {
  margin-left: 4% !important;
}
.margin-left-5Perc {
  margin-left: 5%;
}
.margin-left-6Perc {
  margin-left: 6%;
}

.margin-left-9Perc {
  margin-left: 9%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-Left-2Point1Perc {
  padding-left: 2.1% !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-color-red {
  background-color: red;
}
.cf-border {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-20px {
  font-size: 20px;
}
.background-gray {
  background-color: #ddd;
}

.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}
.font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-34Point2Perc {
  width: 34.2%;
}
.margin-auto {
  margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Perc {
  padding-right: 0% !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.left-border {
    border-left: 1px solid #aaa;
}
.padding-Left-2Point6Perc {
    padding-left: 2.6% !important;
}
.padding-Left-5Point8Perc {
    padding-left: 5.8% !important;
}
.Padding-left-32px {
  padding-left: 32px !important;
}
.width-69Perc {
  width: 69% !important;
}
.width-12Point5Perc{
  width:12.5%;
}
.padding-left-12px{
  padding-left:12px;
}
.width-1Perc{
  width:1%;
}
.margin-top-2px{
  margin-top:2px;
}
.margin-right-9px{
  margin-right:9px;
}
.width-14Point5Perc{
  width:14.5%;
}
.margin-right-1Point1Perc{
  margin-right: 1.1%;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/meditation/SearchLeapsMeditation.vue